import { defineStore } from 'pinia'
export type UserStoreReturnType = ReturnType<typeof useAuthStore>

interface ApplicationUser {
  id: string
  firstName: string
  lastName: string
  email: string
}

export type UserStore = {
  user: ApplicationUser | null
  accessToken: string | null
  refreshToken: string | null
  roles: string[]
  errorMsg: string
  expiresIn: number
  specialties: string[]
}

export const useAuthStore = defineStore('auth', {
  state: (): UserStore => ({
    user: null,
    accessToken: '',
    refreshToken: '',
    roles: [],
    errorMsg: '',
    expiresIn: 0,
    specialties: [],
  }),
  getters: {
    isLoggedIn(): boolean {
      return !!this.accessToken
    },
  },
  actions: {
    addRole(role: string): void {
      this.roles.push(role)
    },
    addSpecialty(specialty: string): void {
      this.specialties.push(specialty)
    },
    changeUserName(fullName: string) {
      if (this.user) {
        this.user.firstName = fullName.split(' ')[0]
        this.user.lastName = fullName.split(' ')[1]
      }
    },
  },
  persist: true,
})
